import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(() => ({
  container: {
    padding: 8
  },
  select: {
    display: 'flex',
    padding: 10,
    borderRadius: 6,
    cursor: 'pointer',
    '&:hover': {
      background: '#f7f7f8'
    }
  },
  label: {
    marginLeft: 10,
    fontSize: 14,
    fontWeight: 400
  },
  sectionTitle: {
    color: '#6A728F',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 12,
    marginBottom: 10
  }
}));

type State = {
  nameASC: boolean;
  nameDESC: boolean;
  expiringASC: boolean;
  expiringDESC: boolean;
};

type Props = {
  onChange?: (state: State) => void;
  state: State;
};

export default function DelegatesSortOptions({ state, onChange }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.sectionTitle}>SORT BY</div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              nameASC: !state.nameASC,
              nameDESC: false,
              expiringASC: false,
              expiringDESC: false
            });
        }}
      >
        <input type="checkbox" checked={state.nameASC} />
        <div className={classes.label}>Name A-Z</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              nameASC: false,
              nameDESC: !state.nameDESC,
              expiringASC: false,
              expiringDESC: false
            });
        }}
      >
        <input type="checkbox" checked={state.nameDESC} />
        <div className={classes.label}>Name Z-A</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              nameASC: false,
              nameDESC: false,
              expiringASC: !state.expiringASC,
              expiringDESC: false
            });
        }}
      >
        <input type="checkbox" checked={state.expiringASC} />
        <div className={classes.label}>Expiring Soonest</div>
      </div>
      <div
        className={classes.select}
        onClick={() => {
          onChange &&
            onChange({
              nameASC: false,
              nameDESC: false,
              expiringASC: false,
              expiringDESC: !state.expiringDESC
            });
        }}
      >
        <input type="checkbox" checked={state.expiringDESC} />
        <div className={classes.label}>Expiring Latest</div>
      </div>
    </div>
  );
}
